import EntityModel from '@/common/models/entity-model';
import WebhookAuthorizationModel from '@/common/models/webhook-authorization-model';
import {getHost} from '@/common/helpers/url';

export default class WebhookCredentialModel extends EntityModel {
    hydrate({
        host = '',
        auth,
    } = {}) {
        this.host = host;
        this.auth = new WebhookAuthorizationModel(auth);
    }

    parseHostFromUrl(url) {
        this.host = getHost(url);
    }

    getPayload() {
        return {
            host: this.host,
            auth: this.auth.getPayload(),
        };
    }
}
